import styled from 'styled-components'
import logofarmasis from "../../imgs/farmasis.png"
import compartir from "../../imgs/compartir.png"
import check from "../../imgs/check.png"
import {baseURLCompartido} from "../../services/authentication.js"
import {useDispatch,useSelector} from 'react-redux';
import {urlVideo,open,setId,setIdCopy} from "../../redux/actions.js"





let Container=styled.div`
	position:relative;
	height:180px;
	min-width:300px;
	max-width:320px;
	display:flex;
	align-items:center;
	flex-direction:column;
	border-radius:25px;
	border: 3px solid orange;
	transition-duration: 500ms;
	box-shadow: 0.125rem 0.25rem 0.25rem 0.5rem oklch(0.1 0.37 315 / 0.25);
	&:hover{
	   border-Color:green;
	   scale:1.1;
		};
`

let VideoTutorial=styled.div`
	height:100%;
	width:100%;
	border-radius:23px 23px 0px 0px;
	background-image:url(${logofarmasis});
	background-size:cover;
	background-repeat:no-repeat;
	transition-duration:600ms;
	&:hover{
		opacity:0.2; 
	};
`

let TituloTutorial=styled.div`

	display:flex;
	background-color:white;
	width:100%;
	align-items:center;
	font-family: 'Poppins', sans-serif;
	justify-content:center;
	border-radius:0px 0px 21px 21px;
	color: #01578c;
	font-size:13px;	
	transition-duration:500ms;
	@media(max-width:450px){
		font-size:14px
	};
	
`
const TextoTitulo=styled.div`
text-align:center;
&:hover{
		background-image: linear-gradient(
        45deg,
        #CA4246 27.666%, 
        #E16541 27.666%, 
        #E16541 29.333%, 
        #F18F43 29.333%, 
        #F18F43 40%, 
        #8B9862 40%, 
        #8B9862 50.666%, 
        #476098 50.666%, 
        #476098 63.333%, 
        #A7489B 63.333%);
        -webkit-background-clip: text;
  		-webkit-text-fill-color: transparent;
  		background-size: 100%;
  	}
 `

let DescripcionTutorial=styled.div`
	position:absolute;
	height:150px;
	width:100%;
	border-radius:22px 22px 0px 0px;
	display:flex;
	background-color:white;
	justify-content:center;
	text-align: center;
	align-items:center;
	z-index:-5;
	font-size:17px;	
`

const DivCompartir=styled.div`
	color:red;
	display:flex;
	align-items:center;	
	display:flex;
	width:25px;
	transition:width 500ms;
	&:hover{
		width:105px;
	}
`
const MsjCompartir=styled.div`
	overflow:hidden;
	transition :width 100ms;
	height:20px;
`;


const CompartirCheck=styled.img`
	height:25px;
	padding:5px		
`

 

export default function Card(props){
	let tutorial=props.video;
	let idCopied=useSelector(state=>state.idCopied)
	const dispatch=useDispatch();  

			

	let chageIcon=(id)=>{
		let icons=document.getElementsByClassName("icon");
	 	for (let i=0;i<icons.length;i++){ icons[i].src=compartir };	
		document.getElementById(id+"ico").src=check;
	};

	let chageColor=(classname,id)=>{
		let texts=document.getElementsByClassName(classname);
		for (let i=0;i<texts.length;i++){ texts[i].style.color="red" };
	 	document.getElementById(id+"copiar").style.color="green"	
	}	
	
	 	
	

	let share=(nombre,id)=>{
		 	//const token=getToken();
			chageIcon(nombre);
			navigator.clipboard.writeText(`${baseURLCompartido}/Compartido/Reproductor/${id}`);
			chageColor("copiar",id);
			dispatch(setIdCopy(tutorial.ID))						
	};	

	

	let handleClick=(id,idVideo)=>{	

			document.getElementById(id).style.borderColor="green";
			dispatch(urlVideo(tutorial.video));
			dispatch(open(true));
			dispatch(setId(tutorial.ID))
	};


	return(
		
		<Container className="card" id={tutorial.name} >		

			<VideoTutorial onClick={()=>handleClick(tutorial.name,tutorial.ID)} style={{backgroundImage:tutorial.poster?`url(${tutorial.poster})`:`url(${logofarmasis})`}} />			
		 	

     		<DescripcionTutorial id={tutorial.name+"Descrip"} className="Descrip" >
     			<i style={{width:'90%'}}>{tutorial.descrip}</i>
     		</DescripcionTutorial>
		 
		 	<TituloTutorial id={tutorial.name+"Tit"}>
		     	<TextoTitulo><b>{tutorial.name}</b></TextoTitulo> 
		        <DivCompartir title={idCopied===tutorial.ID?"Link copiado":"click para copiar el link"}  id={tutorial.ID+"copiar"} className="copiar" onClick={()=>share(tutorial.name,tutorial.ID)}  > 
		        	<CompartirCheck title={idCopied===tutorial.ID?"Link copiado":"click para copiar el link"} id={tutorial.name+"ico"} className="icon"  src={compartir}/> 
		        	<MsjCompartir >{idCopied===tutorial.ID?"Copiado":"copiar Link"}</MsjCompartir>
		        </DivCompartir>
		    </TituloTutorial>		     		 
		
		</Container>

	)
}